export default __webpack_public_path__ + "static/favicon-06de9a6de293917aa4edb6ec89dddefa.ico";